var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubdivisionTool(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "580px",
    height: "580px",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 5800 5800",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "object_cube icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "object_cube icon from the IconExperience.com I-Collection. Copyright by INCORS GmbH (www.incors.com).")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: "10px"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m686.12 3389 2268.2-1015.1 2264.5 1008-2412.5 1420.1z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m686.12 3860.5v-457.31l2120.2 1398.8v457.31z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2806.3 5259.3v-457.31l2412.5-1420.1v457.31z",
    fill: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1695.8 4067.4 1253.4-663.56 1118.2 657.42-1261.1 740.76z",
    fill: "#73b0fd",
    stroke: "#0259c6",
    strokeWidth: 30
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(37.794 0 0 37.794 670.54 -6003.8)",
    stroke: "#000",
    strokeWidth: ".25667px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m62.801 259.12s44.783-54.255 48.351-58.399c3.5684-4.1445 8.2072-8.6657 10.883-5.2748 2.4978 3.0142 0.35684 6.2167-4.1036 11.491-0.73066 0.91175-7.6931 9.3173-16.146 19.51-14.252 17.186-32.741 39.454-32.741 39.454-1.4934-9.4454-0.92079-3.7688-6.2446-6.7819z",
    fill: "#51594e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.664 273.44 13.381-7.5354-1.4273-5.4632-4.8173-1.3187z",
    fill: "#f3f097"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.664 273.44 2.6763-4.898 2.141 2.2606z",
    fill: "#040405"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubdivisionTool);
export default __webpack_public_path__ + "static/media/subdivision_tool.9aaae8427a77a1ecc27150372767ca0e.svg";
export { ForwardRef as ReactComponent };